import api from '@/api'

const state = {
  cgList: [],
}

const mutations = {
  SET_CG_LIST(state, list) {
    state.cgList = list
  },
}

const actions = {
  // 获取硬件配置相关的软件列表（沿用原 node/hardwareConfiguration 逻辑）
  async getAllCgInfoMap({ state, commit }, payload) {
    if (state.cgList.length > 0) return false
    const res = await api.nodeApi.getHardwareConfigurationList(payload)
    if (res.data && res.code === 200) {
      commit('SET_CG_LIST', res.data)
    }
  },
  getCheckedTree({ getters }, payload) {
    const checkedList = []
    for (const [, values] of getters.cgTreeMap) {
      for (const x of new Set(payload)) {
        for (const child of new Set(values)) {
          if (child.id === x) {
            checkedList.push({
              id: child.id,
              cgVersion: child.label,
              cgId: child.cgId,
              cgName: child.cgName,
            })
          }
        }
      }
    }
    return checkedList
  },
  // 根据 cgId 获取软件版本列表
  getCgVersionListByCgId({ getters }, cgId) {
    if (!cgId) return []
    const cgTreeMap = getters.cgTreeMap
    const children = cgTreeMap.get(cgId) || []
    // 转换为与 API 返回格式一致的结构 {id, cgVersion, ...}
    return children.map(child => ({
      id: child.id,
      cgVersion: child.label,
      cgId: child.cgId,
      cgName: child.cgName,
    }))
  },
}

const getters = {
  cgTree(state) {
    return state.cgList.reduce((result, item) => {
      const group = result.find(g => g.id === item.cgId)
      if (group) {
        group.children.push({
          id: item.id,
          label: item.cgVersion,
          cgId: item.cgId,
          cgName: item.cgName,
        })
      } else {
        result.push({
          id: item.cgId,
          label: item.cgName,
          children: [{
            id: item.id,
            label: item.cgVersion,
            cgId: item.cgId,
            cgName: item.cgName,
          }],
        })
      }
      return result
    }, [])
  },
  cgTreeMap(state, getters) {
    return new Map(getters.cgTree.map(item => [item.id, item.children]))
  },
  cgTreeList(state, getters) {
    return getters.cgTree.map(item => [item])
  },
  wrinkleTreeList(state, getters) {
    return getters.cgTree.reduce((result, item) => {
      result.push(item.children)
      return result
    }, [])
  },
  // 根据 cgId 获取软件版本列表
  getCgVersionListByCgId: (state, getters) => (cgId) => {
    if (!cgId) return []
    const cgTreeMap = getters.cgTreeMap
    const children = cgTreeMap.get(cgId) || []
    // 转换为与 API 返回格式一致的结构 {id, cgVersion, ...}
    return children.map(child => ({
      id: child.id,
      cgVersion: child.label,
      cgId: child.cgId,
      cgName: child.cgName,
    }))
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
